import { Grid, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import classNames from 'classnames'
import React from 'react'

const useStyles = makeStyles()((theme) => ({
  bold: {
    fontWeight: 800,
  },
  marginB: {
    marginBottom: theme.spacing(1),
  },
}))

function IdealRotation({ children, title = 'Ideal Rotation' }) {
  const { classes } = useStyles()

  return (
    <Grid item xs={12} md={4}>
      <blockquote>
        <Typography
          className={classNames(classes.bold, classes.marginB)}
          variant="subtitle1"
        >
          {title}
        </Typography>
        {children}
      </blockquote>
    </Grid>
  )
}

export default IdealRotation
